import axios from 'axios';

const api = axios.create({
  baseURL: 'https://orthoquiz-api.herokuapp.com/',
});

export default api;
